import isEmpty from 'lodash/isEmpty';
import type { HashDiff } from '../hash-diff';

export const isHashModified = <T,>(hashDiff: HashDiff<T>) =>
	!isEmpty(hashDiff.added) || !isEmpty(hashDiff.changed) || !isEmpty(hashDiff.removed);
